export default "__VITE_ASSET__DgUnjkfN__"